import { SenderDetails } from "../types/common";
import { Box, Typography } from "@mui/material";

type Props = {
  senderDetails: SenderDetails;
  renderIcon: () => JSX.Element | null;
};

const InboxRowPrimaryText = ({ senderDetails, renderIcon }: Props) => {
  if (senderDetails?.topic) {
    return (
      <Box
        display="flex"
        alignItems="center"
        gap="6px"
        minWidth={0}
        overflow="visible"
      >
        <Typography
          variant="body1"
          color="text.primary"
          fontSize="16px"
          fontWeight={600}
          noWrap
          sx={{ flex: "0 1 auto", minWidth: 0, lineHeight: "20px" }}
        >
          {senderDetails.topic}
        </Typography>
        {senderDetails.icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              overflow: "visible",
            }}
          >
            {renderIcon()}
          </Box>
        )}
      </Box>
    );
  }

  if (senderDetails.name) {
    return (
      <Box
        display="flex"
        alignItems="center"
        gap="6px"
        minWidth={0}
        overflow="visible"
      >
        <Box
          sx={{
            flex: "0 1 auto",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: "20px",
          }}
        >
          {senderDetails.name}
        </Box>
        {senderDetails.icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              overflow: "visible",
            }}
          >
            {renderIcon()}
          </Box>
        )}
      </Box>
    );
  }

  return null;
};

export default InboxRowPrimaryText;
